import { Box, Collapse, Typography } from "@mui/material";
import { DotLegalLink, DotLegalSelect, DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { useCrvSelectorHooks } from "./CvrSelector.hooks";
import { useTranslation } from "../../localization/useTranslation";
import { CvrResultViewModel } from "./CvrSelector.types";
import { usePlanContext } from "../../auth/planProvider/PlanProvider";
import PurpleLockSvg from "../../common/svgs/purpleLock.svg?react";
import { useUrlProvider } from "../../useUrlProvider";
import { isNullOrWhitespace } from "../../common/stringOperations";

export interface ICrvSelector {
    onSelectLegalEntity: (selector: CvrResultViewModel) => void;
    onLegalEntityRemoved: () => void;
}

function CvrSelector(props: ICrvSelector) {
    const { translateString } = useTranslation();
    const { results, inputValue, setShowCvr, showCvr, onSelectResult, hasFocus, setHasFocus, noDataFound, setInputValue } = useCrvSelectorHooks(props);
    const { addonsFeatures } = usePlanContext();
    const { getPurchasePlansUrl } = useUrlProvider();

    const purchasePrivacy = () => {
        window.location.href = getPurchasePlansUrl();
    };

    function renderCvrSearchToggle() {
        if (addonsFeatures.cvr) {
            return (
                <DotLegalLink
                    linkColor="primary"
                    onClick={() => {
                        if (showCvr) {
                            props.onLegalEntityRemoved();
                            setShowCvr(false);
                        } else {
                            setShowCvr(true);
                        }
                    }}
                >
                    {showCvr ? translateString("closeCvr") : translateString("searchInCvr")}
                </DotLegalLink>
            );
        }

        return (
            <DotLegalTooltip text={translateString("upgradeToActivateAddOn")}>
                <span>
                    <DotLegalLink noUnderlineOnHover linkColor="primary" onClick={() => purchasePrivacy()}>
                        <Box sx={{ display: "flex", gap: 1, alignItems: "center", "& svg": { height: 16, width: "auto" } }}>
                            {translateString("searchInCvr")} <PurpleLockSvg />
                        </Box>
                    </DotLegalLink>
                </span>
            </DotLegalTooltip>
        );
    }

    return (
        <>
            <Box sx={{ fontSize: (theme) => theme.typography.pxToRem(14) }}>{renderCvrSearchToggle()}</Box>
            <Collapse in={showCvr}>
                <Box sx={{ marginTop: 1 }}>
                    <DotLegalSelect
                        options={results.map((x) => {
                            return { id: x.companyRegistrationNumber.toString(), name: x.name + " - " + x.companyRegistrationNumber.toString() };
                        })}
                        onChange={onSelectResult}
                        label={hasFocus ? translateString("search") : translateString("cvrSearchLabel")}
                        noOptionsLabel={
                            isNullOrWhitespace(inputValue)
                                ? translateString("cvrSearchLabel")
                                : noDataFound
                                  ? translateString("noCvrDataFound")
                                  : translateString("loading")
                        }
                        searchValue={inputValue}
                        onSearchValueChange={setInputValue}
                        icon={<div></div>}
                        onFocus={() => setHasFocus(true)}
                        onBlur={() => setHasFocus(false)}
                        clearOnSelect
                        noMargin
                    />
                </Box>
            </Collapse>
        </>
    );
}

export default CvrSelector;
